import { ExternalTransactionStatus } from '@helios/common-api'
import { TransferPositionData } from './direct-transfer/direct-transfer-transaction.model'
import { TranLink } from './tran-link.model'

type PositionType = 'Cash' | 'Position' | 'Margin'

export enum TransactionModalMode {
  CreateFromExtTran,
  CreateCWTran,
  EditCWTran,
  CreateFromPosition,
}

export interface TransactionModalInput {
  modalMode: TransactionModalMode
  readOnly?: boolean
  transactionId?: string
  origTransactionId?: number
  securityId?: number
  tranLinkInfo?: TranLink
  transType?: string
  externalTransactionStatus?: ExternalTransactionStatus
  positionData?:
    | ExchangePositionData
    | HistoricalBalanceData
    | TransferPositionData
  transactionBasis?: string
}

export interface ExchangePositionData {
  oldCusip: string
  oldCwanIdentifier?: string
  newCusip: string
  newCwanIdentifier?: string
  rate: number
  units: number
  collateralBroker?: string
}

export interface HistoricalBalanceData {
  posType: PositionType
  date: string
  assetId: string
  unitDifference: number
  currencyCode: string
  securityId: number
  price?: string
  collateralBroker?: string
}
